<template>
    <div class="container-fluid">
        <div class="container-fluid" v-if="activePageCRU==0">
            <div class="row mb-1">
              <div class="col-sm pb-1 text-start">
                <span class="badge rounded-pill bg-info pull-left mt-1 py-2 px-4" style="font-size:18px; background:white">
                    <b>Lab Request : ใบสั่งตรวจ V.2</b>
                </span>
                <div class="form-check form-check-inline mx-3 pt-2" title="แสดงรายการที่ป้อนผลแล้วรออนุมัติ">
                  <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="0" checked @click.prevent="">
                  <label class="form-check-label" for="inlineCheckbox1"><b>New</b> </label>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col-sm">
                    <div class="row">
                      <div class="col-4">
                          <!-- สาขาแล็บ -->
                          <div class="input-group input-group-sm">
                              <div class="input-group-prepend">
                              <span class="input-group-text" style="width:120px;">สาขา* :</span>
                              </div>
                              <select class="form-select form-select-sm" ref="BranchID" id="BranchID" name="BranchID" v-model="branchID">
                                  <option disabled value="">Please select one</option>
                                  <option v-for="item in dataBranchlists" :key="item.BranchID" :value="item.BranchID">{{ item.BranchName }}</option>
                              </select>
                          </div>
                      </div>
                      <div class="col-7">
                          <!-- วันที่ใบสั่งตรวจ -->
                          <div class="input-group input-group-sm mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" style="width:120px;">วันที่เอกสาร</span>
                            </div>
                            <v-date-picker mode="date" v-model="dateFm" :masks="masks" title="วันที่เอกสารเริ่มต้น">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <input name="dateFm" ref="dateFm" style="width:120px;"
                                    class="bg-white border px-2 py-1 rounded"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                            <v-date-picker mode="date" v-model="dateTo" :masks="masks" title="วันที่เอกสารสิ้นสุด">
                                  <template v-slot="{ inputValue, inputEvents }">
                                      <input name="dateTo" ref="dateTo" style="width:120px;"
                                      class="bg-white border px-2 py-1 rounded"
                                      :value="inputValue"
                                      v-on="inputEvents"
                                      />
                                  </template>
                            </v-date-picker>
                            <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="getData()">ดึงข้อมูล</button>
                          </div>
                      </div>
                      <div class="col-1">
                          <button type="button" class="btn btn-primary btn-sm text-white float-end mx-2 mt-1"
                            style="width:100px;" @click="newRecord()">New</button>
                      </div>
                    </div>
                </div>
            </div>
            <!-- ตารางใบสั่งตรวจ สถานะใหม่และป้อนผล ตามเงื่อนไขสาขาและวันที่เอกสาร -->
            <LabCreate1View :datalists="datalists" :key="countRefresh"
                @onEditRecordEvent="editRecord"
                @onBackPageAfterSaveEvent="backPageAfterSave"></LabCreate1View>
        </div>
        <!-- <div class="container-fluid" v-if="activePageCRU==1">
            <LabCreate2New
              :dataTestSuitlists="dataTestSuitlists"
              :dataPropacklists="dataPropacklists"
              :dataCliniclists="dataCliniclists"
              :dataOfficerlists="dataOfficerlists"
              :dataBranchlists="dataBranchlists"
              :dataSpecimenlists="dataSpecimenlists"
              @onBackPageEvent="backPage"
              @onBackPageAfterSaveEvent="backPageAfterSave"></LabCreate2New>
        </div> -->
        <!-- หน้าจอแก้ไขใบสั่งตรวจ (ยังไม่ได้ป้อนผล) -->
        <!-- <div class="container-fluid" v-if="activePageCRU==2">
            <LabCreate3Edit
              :rowEdit="curRecord"
              :dataTestSuitlists="dataTestSuitlists"
              :dataCliniclists="dataCliniclists"
              :dataOfficerlists="dataOfficerlists"
              :dataBranchlists="dataBranchlists"
              :dataSpecimenlists="dataSpecimenlists"
              @onBackPageEvent="backPage"
              @onBackPageAfterSaveEvent="backPageAfterSave"></LabCreate3Edit>
        </div> -->
        <div class="container-fluid" v-if="activePageCRU==1">
            <LabCreate2NewPropack
              :dataRoomtypelists="dataRoomtypelists"
              :dataTestSuitlists="dataTestSuitlists"
              :dataPropacklists="dataPropacklists"
              :dataCliniclists="dataCliniclists"
              :dataOfficerlists="dataOfficerlists"
              :dataBranchlists="dataBranchlists"
              :dataSpecimenlists="dataSpecimenlists"
              :dataRemarklists="dataRemarklists"
              @onBackPageEvent="backPage"
              @onBackPageAfterSaveEvent="backPageAfterSave"></LabCreate2NewPropack>
        </div>
        <!-- หน้าจอแก้ไขใบสั่งตรวจ (ยังไม่ได้ป้อนผล) -->
        <div class="container-fluid" v-if="activePageCRU==2">
            <LabCreate3EditPropack
              :rowEdit="curRecord"
              :dataRoomtypelists="dataRoomtypelists"
              :dataTestSuitlists="dataTestSuitlists"
              :dataPropacklists="dataPropacklists"
              :dataCliniclists="dataCliniclists"
              :dataOfficerlists="dataOfficerlists"
              :dataBranchlists="dataBranchlists"
              :dataSpecimenlists="dataSpecimenlists"
              :dataRemarklists="dataRemarklists"
              @onBackPageEvent="backPage"
              @onBackPageAfterSaveEvent="backPageAfterSave"></LabCreate3EditPropack>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import LabCreate1View from './LabCreate1View.vue'
import LabCreate1View from './LabCreate1View.vue'
// import LabCreate2New from './LabCreate2New.vue'
// import LabCreate3Edit from './LabCreate3Edit.vue'
import LabCreate2NewPropack from './LabCreate2NewPropack.vue'
import LabCreate3EditPropack from './LabCreate3EditPropack.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'LabCreate',
  data () {
    return {
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      branchID: 0,
      dateFm: new Date(),
      dateTo: new Date(),
      // status0New: true,
      status1Lab: true,
      status2Res: false,
      // status3App: true,

      countRefresh: 0,
      activePageCRU: 0, // 0-View or Read/ 1-Create/ 2-Update
      // False : แสดงหน้าจอ View,  True : แสดงหน้าจอป้อนผลแล็บ
      datalists: null,
      curRecord: null,
      PatName: '',
      action: 'new',
      // ชุดตรวจสำหรับแสดงใน Modal เพื่อเลือกใส่ใบสั่งตรวจ
      dataTestSuitlists: null,
      // แพคเกจชุดตรวจสำหรับแสดงใน Modal เพื่อเลือกใส่ใบสั่งตรวจ
      dataPropacklists: null,
      // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
      dataCliniclists: null,
      // รายชื่อ พนง ในระบบ สำหรับเลือกใน Header Table
      dataOfficerlists: null,
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null,
      // รายชื่อ specimen ทั้งหมด
      dataSpecimenlists: null,
      // รายชื่อ ห้องตรวจ ทั้งหมด สำหรับใช้กรองชุดตรวจ ขณะเลือก
      dataRoomtypelists: null,
      // รายการ หมายเหตุ
      dataRemarklists: null
    }
  },
  created () {
    // Initial Value
    // this.getOfficerData()
    // this.getBranchData()
  },
  mounted () {
    this.getTestSuitData()
    this.getPropackData()
    this.getClinicData()
    this.getOfficerData()
    this.getBranchData()
    this.getSpecimenData()
    this.getRoomtypeData()
    this.getRemarkData()

    this.branchID = this.globalBranchID
    // ดึงข้อมูลรายการใบสั่งตรวจ
    this.getData()
  },
  components: {
    LabCreate1View,
    // LabCreate2New,
    LabCreate2NewPropack,
    // LabCreate3Edit,
    LabCreate3EditPropack
  },
  methods: {
    getRemarkData () {
      MyApiClient.get('getdata/remarks_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataRemarklists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getData_TestsuitsInRoom (item, index) {
      // MyApiClient.get('getdata/testsuits_all.php?C1=' + this.globalCorpID)
      let phpFile = ''
      if (parseInt(item.RoomType) === 0) {
        if (item.id > 0) {
          phpFile = 'getdata/testsuits_where_roomtype.php'
        } else {
          phpFile = 'getdata/testsuits_all.php'
        }
      } else {
        // ชุดตรวจในแพคเกจที่เป็นเสมือนห้องตรวจ
        phpFile = 'getdata/testsuits_where_multiroomprofile.php'
      }
      MyApiClient.get(phpFile + '?C1=' + this.globalCorpID + '&roomtypeID=' + item.id)
        .then((resp) => {
        //   console.log(resp.data.response)
          item.TS = resp.data.response
          // setTimeout(function () { $('#myTSTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
          item.TS = []
        })
    },
    getRoomtypeData () {
      // MyApiClient.get('getdata/roomtype_all.php?C1=' + this.globalCorpID)
      MyApiClient.get('getdata/roomtype_and_multiroomprofile_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataRoomtypelists = resp.data.response
          this.dataRoomtypelists.forEach(this.getData_TestsuitsInRoom)
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getSpecimenData () {
      MyApiClient.get('getdata/specimen_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataSpecimenlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getBranchData () {
      MyApiClient.get('getdata/branch_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          this.dataBranchlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    getOfficerData () {
      MyApiClient.get('getdata/officers_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataOfficerlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // รายชื่อคลินิกต้นทาง สำหรับเลือกใน Header Table
    getClinicData () {
    // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/clinicreq_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.dataCliniclists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // ชุดตรวจทั้งหมด สำหรับเลือกในใบสั่งตรวจ
    getTestSuitData () {
      // axios.get('http://www.irissar.com/projects/parking/service/park_building/pb_like.php?key=%' + this.search_text + '%', {crossDomain: true})
      MyApiClient.get('getdata/testsuits_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataTestSuitlists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // แพคเกจชุดตรวจทั้งหมด สำหรับเลือกในใบสั่งตรวจ
    getPropackData () {
      MyApiClient.get('getdata/propacks_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataPropacklists = resp.data.response
        })
        .catch((err) => {
          console.log(err.response)
        })
    },
    // Callback หลังจาก 1-บันทึกเอกสารใหม่ และ 2-ยกเลิกเอกสาร
    backPageAfterSave () {
      this.curRecord = {}
      this.action = 'new'
      this.activePageCRU = 0
      this.$nextTick(() => {
        $('#myLabReqTable').DataTable()
      })
      // ดึงข้อมูลรีเฟรชตารางใบสั่งตรวจ
      this.getData()
    },
    backPage () {
      this.curRecord = {}
      this.action = 'new'
      this.activePageCRU = 0
      this.$nextTick(() => {
        $('#myLabReqTable').DataTable()
      })
    },
    newRecord () {
      this.curRecord = {}
      this.action = 'new'
      this.activePageCRU = 1 // 0-View 1-New 2-Edit
    },
    editRecord (row) {
      this.curRecord = row
      this.action = 'edit'
      this.activePageCRU = 2 // 0-View 1-New 2-Edit
    },
    getData () {
      // -------- Date From -----------
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateFm = YYYY + '-' + MM + '-' + DD
      // -------- Date To -----------
      d = this.dateTo
      YYYY = d.getFullYear().toString()
      MM = ''
      DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateTo = YYYY + '-' + MM + '-' + DD
      var BranchID = this.branchID
      //   var Status1 = -1 // 1-Lab
      //   var Status2 = -1 // 2-Resulted
      //   if (this.status1Lab) {
      //     Status1 = 1 // 1-Lab
      //   }
      //   if (this.status2Res) {
      //     Status2 = 2 // 2-Resulted
      //   }
      MyApiClient.get('getdata/labrequest_where.php?C1=' + this.globalCorpID +
      '&BranchID=' + BranchID + '&DocDateFm=' + docDateFm + '&DocDateTo=' + docDateTo)
        .then((resp) => {
          // console.log(resp.data.response)
          this.datalists = resp.data.response
          if (this.datalists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          //   setTimeout(function () { $('#myLabReqTable1').DataTable() }, 0)
          setTimeout(function () { $('#myLabReqTable').DataTable() }, 0)
          this.countRefresh++
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>
.page-scroll {
  max-height: 450px;
  height: 400px;
  overflow-y: scroll;
  /* height: 450px;
  overflow-y: scroll; */
}
</style>
